export enum AclWorkflowAccessLevel {
  AllMyPlatform = "AllMyPlatform",
  OnlyMyPlatformGroup = "OnlyMyPlatformGroup",
  OnlyMine = "OnlyMine",
}
